import { SidebarItemsType } from "../../types/sidebar";

import {
  Bell,
  BookOpen,
  Briefcase,
  Calendar,
  CheckSquare,
  Grid,
  Heart,
  Home,
  Layout,
  List,
  PieChart,
  Sliders,
  MapPin,
  Users,
  Share,
  Trello,
} from "react-feather";

const pagesSection = [
  {
    href: "/",
    icon: Home,
    title: "Visualisations",
  },
  {
    href: "/companies",
    icon: Briefcase,
    title: "Companies List",
  }
];

// const navItems = [
//   {
//     title: "Pages",
//     pages: pagesSection,
//   },
// ];

export default pagesSection;
